/* ══════════════════════════════════════════════════════════════════════
   PAST WINNERS — vanilla port of the handoff's DCLogic class.
   Everything is scoped to .tws-pw so the locked chrome and footer are
   never touched.

   NOT PORTED: _initRail. It drove #scrollRail, which lives in the
   handoff's own header — replaced here by the locked TWS chrome.

   ⚠ No single wrapper root. On Shopify each section emits its OWN
   .tws-pw, so querySelector('.tws-pw') would return the hero and every
   lookup beneath it would come back empty — the bug that killed the
   filters on three earlier pages. Every query below runs against the
   document with a .tws-pw prefix instead.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__twsPwInit) return;
  window.__twsPwInit = true;

  var $$ = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };
  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* data-rv value -> pw-prefixed keyframe. The chrome sheet defines its own
     rise / riseS / inL, so the page must never animate the bare names. */
  var KF = { rise: 'pwRise', riseS: 'pwRiseS', podium: 'pwPodium',
             inL: 'pwInL', seal: 'pwSealIn' };

  function splitWords() {
    var heads = $$('.tws-pw h1, .tws-pw section h2');
    function wrap(el) {
      Array.prototype.slice.call(el.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          if (!n.textContent.trim()) return;
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (p) {
            if (!p) return;
            if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
            var s = document.createElement('span');
            s.className = 'sw';
            var i = document.createElement('i');
            i.textContent = p;
            s.appendChild(i);
            frag.appendChild(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1 && !n.hasAttribute('data-nosplit') &&
                   !n.classList.contains('sw') && n.tagName !== 'svg' && n.tagName !== 'A') {
          wrap(n);
        }
      });
    }
    heads.forEach(function (h) {
      if (h.getAttribute('data-split')) return;
      h.setAttribute('data-split', '1');
      wrap(h);
      var words = h.querySelectorAll('.sw');
      var fire = function () {
        words.forEach(function (w, i) {
          w.classList.add('on');
          w.firstChild.style.animationDelay = (i * 52) + 'ms';
        });
      };
      if (REDUCE || h.getBoundingClientRect().top < innerHeight * 0.9 ||
          typeof IntersectionObserver === 'undefined') { fire(); return; }
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { fire(); io.disconnect(); } });
      }, { threshold: 0.15 });
      io.observe(h);
    });
  }

  function initRules() {
    var rules = $$('.tws-pw .gold-rule');
    if (!rules.length || REDUCE || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.style.animation = 'ruleIn .9s cubic-bezier(.22,.7,.25,1) both';
        io.unobserve(e.target);
      });
    }, { threshold: 0.3 });
    rules.forEach(function (r) { io.observe(r); });
  }

  function show(el) {
    var kind = KF[el.getAttribute('data-rv') || 'rise'] || 'pwRise';
    var d = parseInt(el.getAttribute('data-rv-d') || '0', 10);
    el.style.animation = kind + ' .82s cubic-bezier(.22,.7,.25,1) ' + d + 'ms both';
    el.style.opacity = '';
  }

  function initReveal() {
    var els = $$('.tws-pw [data-rv]');
    if (!els.length || REDUCE || typeof IntersectionObserver === 'undefined') return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        show(e.target);
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.06 });
    els.forEach(function (el) {
      /* Only hide what is genuinely below the fold. A reveal must never be the
         only route back to visible — anything already on screen is left alone,
         which is what stopped the Packages section rendering blank. */
      if (el.getBoundingClientRect().top > innerHeight * 0.88) {
        el.style.opacity = '0';
        io.observe(el);
      }
    });

    /* ⚠ FAILSAFE — IntersectionObserver does NOT deliver while the tab is
       backgrounded. Measured on this page: 6 reveals scrolled into view,
       all still opacity:0 after 1.2s with visibilityState "hidden". Without
       this sweep, a page opened in a background tab and focused later would
       show its hero and nothing else — exactly how the Author Registration
       page failed. The sweep only touches elements already in the viewport,
       so it can never pre-empt an animation further down the page. */
    function sweep() {
      els.forEach(function (el) {
        if (el.style.opacity !== '0') return;
        var b = el.getBoundingClientRect();
        if (b.top < innerHeight && b.bottom > 0) { show(el); io.unobserve(el); }
      });
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) sweep();
    });
    addEventListener('load', sweep);
  }

  /* ⚠ NOT wrapped in requestAnimationFrame, though the handoff was.
     rAF does not fire while the tab is backgrounded, so a page opened in a
     background tab initialised NOTHING: measured here with __twsPwInit true,
     data-split null and 0 .sw spans on the whole page. The failure was the
     safe kind — no reveal ran, so nothing was hidden — but it left the page
     non-deterministic and unverifiable. Calling directly needs no frame:
     getBoundingClientRect forces layout on its own. */
  /* Tag Urdu piece titles so the Nastaliq line-height rule applies. Done here,
     not in the markup, because Liquid has no regex — this is the only way the
     local page and the Shopify sections can agree. Never sets `dir`: that would
     make text-align:start resolve right and push the title to the far margin,
     away from the writer's name. */
  var URDU = /[\u0600-\u06FF\u0750-\u077F\uFB50-\uFDFF\uFE70-\uFEFF]/;
  function tagUrdu() {
    $$('.tws-pw .win-title, .tws-pw .ru-title').forEach(function (el) {
      if (URDU.test(el.textContent)) el.setAttribute('lang', 'ur');
    });
  }

  /* Smooth-scroll the cycle chips.

     ⚠ THE NATIVE ANCHOR JUMP IS NEVER PREVENTED. The first version called
     preventDefault and drove the scroll with scrollIntoView({behavior:'smooth'})
     — which does NOTHING in a backgrounded tab (measured: scrollY stayed 0 while
     'auto' moved it 2707px), and a chip that scrolls nowhere is worse than one
     that jumps. So the browser always performs the navigation, and this only
     decorates it: `scroll-behavior` is set inline for a second and removed.
     If smooth is unsupported or throttled, the visitor gets the instant jump.

     Set on documentElement rather than in the stylesheet so it cannot leak to
     every anchor on the site, and skipped entirely under reduced motion. The
     articles' scroll-margin-top:110px clears the sticky header either way —
     verified landing at exactly 110px. */
  function initJumps() {
    $$('.tws-pw .pw-chips .chip').forEach(function (a) {
      a.addEventListener('click', function () {
        if (REDUCE) return;
        var root = document.documentElement;
        root.style.scrollBehavior = 'smooth';
        setTimeout(function () { root.style.scrollBehavior = ''; }, 1000);
      });
    });
  }

  function boot() { tagUrdu(); splitWords(); initReveal(); initRules(); initJumps(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
